import React, { Fragment } from 'react';
interface PageLayoutProps {
  title: string;
  /** Supporting subtitle shown below title */
  description?: string;
  /** Alias for description */
  subtitle?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  breadcrumbs?: Array<{
    label: string;
    href?: string;
  }>;
}
export function PageLayout({
  title,
  description,
  subtitle,
  actions,
  children,
  className = '',
  breadcrumbs
}: PageLayoutProps) {
  const displayDescription = description ?? subtitle;
  return <div className={`flex flex-col h-full min-h-0 ${className}`} data-id="element-4556">
      {/* Header - desktop only */}
      <div className="flex-shrink-0 px-4 py-4 sm:px-6 sm:py-5 border-b border-gray-100 bg-white/80 backdrop-blur-sm hidden md:block" data-id="element-4557">
        {breadcrumbs && breadcrumbs.length > 0 && <div className="flex items-center gap-1.5 mb-2" data-id="element-4558">
            {breadcrumbs.map((crumb, i) => <Fragment key={i} data-id="element-4559">
                {i > 0 && <span className="text-gray-300 text-xs" data-id="element-4560">/</span>}
                <span className="text-xs text-gray-400" data-id="element-4561">{crumb.label}</span>
              </Fragment>)}
          </div>}
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3" data-id="element-4562">
          <div className="min-w-0 flex-1" data-id="element-4563">
            <h1 className="text-lg sm:text-xl font-semibold text-gray-900 leading-tight" data-id="element-4564">
              {title}
            </h1>
            {displayDescription && <p className="text-sm text-gray-500 mt-0.5 line-clamp-1 sm:line-clamp-none" data-id="element-4565">
                {displayDescription}
              </p>}
          </div>
          {actions && <div className="flex items-center gap-2 flex-shrink-0" data-id="element-4566">
              {actions}
            </div>}
        </div>
      </div>

      {/* Mobile actions bar - shown only on mobile when actions exist */}
      {actions && <div className="flex-shrink-0 px-4 pt-3 pb-1 md:hidden" data-id="element-4567">
          <div className="flex items-center gap-2" data-id="element-4568">{actions}</div>
        </div>}

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-4 py-4 sm:px-6 sm:py-5" data-id="element-4569">
        {children}
      </div>
    </div>;
}